import { 
  SET_PROJECTS, 
  UPDATE_PROJECTS_LIST, 
  UPDATE_NEW_PROJECT, 
  UPDATE_COMPETITION_CHANGE,
  REMOVE_ACCEPTED_PROJECT
} from './types'

const projectState = {
    projects: [],
}

const updateProjectList = (oldList, currentList) => {

  const result = [ ...oldList, ...currentList ]

  let filter = result.filter((cur, i, a)=> a.findIndex(item => (item._id === cur._id) ) === i)

  return filter

}

const updateNewProject = (oldList, project) => {

  const hasProject = oldList.find(item => item._id === project._id)

  if (hasProject) return oldList

  let result = [ project, ...oldList ];

  let filter = result.filter((cur, i, a)=> a.findIndex(item => (item._id === cur._id) ) === i)

  return filter
  
}

const updateCompetitionNumber = (oldList, project) => {

  const result = [ ...oldList ]

  const updated = result.map(item => {

    if (item._id === project._id) {
      let copy = { ...item }
      copy.competitors_number = project.competitors_number
      return copy
    }

    return item

  })

  let filter = updated.filter((cur, i, a)=> a.findIndex(item => (item._id === cur._id) ) === i)

  return filter

}

const updateCompetitionAdded = (oldList, id) => {

  const list = [ ...oldList ]

  const updated = list.filter(item => item._id !== id)

  return updated

}

const projectsReducer = (state, actions) => {
    const { type, payload } = actions

    switch (type) {
        case SET_PROJECTS:
          return {
              ...state,
              projects: payload,
          }
        case UPDATE_PROJECTS_LIST: {
            return {
                ...state,
                projects: updateProjectList(state.projects, payload)
            }
        }
        case UPDATE_NEW_PROJECT: {
          return {
            ...state,
            projects: updateNewProject(state.projects, payload)
          }
        }
        case UPDATE_COMPETITION_CHANGE: {
          return {
            ...state,
            projects: updateCompetitionNumber(state.projects, payload)
          }
        }
        case REMOVE_ACCEPTED_PROJECT: {
          return {
            ...state,
            projects: updateCompetitionAdded(state.projects, payload.id)
          }
        }
        default: {
          return state
        }
    }
}

export { projectsReducer as default, projectState }